// extracted by mini-css-extract-plugin
export var sidebar = "iGigD";
export var sidebarHorizontal = "UkzG7";
export var sidebarVertical = "BNIx4";
export var sidebarVerticalThreeQuarters = "GNuFB";